import { render, staticRenderFns } from "./CategoryMenuButton.vue?vue&type=template&id=b09e71fc&scoped=true&"
import script from "./CategoryMenuButton.vue?vue&type=script&lang=js&"
export * from "./CategoryMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMenuButton.vue?vue&type=style&index=0&id=b09e71fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09e71fc",
  null
  
)

export default component.exports